import { startThemeMode } from '~/composables/useThemeMode'

/** Light, dark or the device's setting: see composables/useThemeMode.ts */
export default defineNuxtPlugin(() => {
  startThemeMode()
})
